<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Pengurusan Inventori">
      <div class="table_scrol">
        <div class="w-card__content content-hardcode mb3">
         <w-select class="mt4"  label="Peranan"  :items="roles"   v-model="pencarian.role_id" />
        <w-form v-model="valid" @validate="cari" ref="frm">
          <w-flex class="mt2">
            <div class="xs6">
              <div class="spacer"></div>
              <div class="spacer"></div>
               <w-input
               v-model="pencarian.no_batch"
               label="No. Batch"
               />
            </div>
            <div class="xs6">
              <div class="spacer"></div>
               <z-select
               v-model="pencarian.se_katalog_id"
               :items="se_katalog"
               label="ID Ternakan"
               style="margin-top: -0.4px;"
               />
            </div>
            
          </w-flex>
        </w-form>

        <w-flex justify-end class="mt2">
                      <w-button class="mr2" v-on:click="resetPencarian()" v-on="on" bg-color="warning">
                    <w-icon class="mr1" md >fal fa-redo</w-icon>SET SEMULA
                </w-button>
                      <w-button class="mr2" bg-color="primary"  v-on="on" @click="$refs.frm.validate()">
                    <w-icon class="mr1" md >fal fa-search</w-icon>CARI
                </w-button>
        </w-flex>
      </div>
		  <z-table title="Senarai Pengurusan Inventori" :headers="table.headers" :items="table.items" :meta="table.meta">
          <template #header-label="{ header, label, index }">
          </template>
            <template #item-cell.jumlah_agih="{ item, label, header, index }">
               <div style="text-align: center;">
                  <template v-if="item.jumlah_agih == null">0</template>
                  <template v-else>{{item.jumlah_agih}}</template>
               </div>
            </template>
            <template #item-cell.rusak="{ item, label, header, index }">
               <div style="text-align: right;">
                  {{item.rusak}}
               </div>
            </template>
            <template #item-cell.hilang="{ item, label, header, index }">
               <div style="text-align: right;">
                  {{item.hilang}}
               </div>
            </template>
            <template #item-cell.terpakai="{ item, label, header, index }">
               <div style="text-align: right;">
                  {{item.terpakai}}
               </div>
            </template>
            <template #item-cell.action="{ item, label, header, index }">
               <w-flex class="flex justify-center">
                  <w-tooltip top color="white" bg-color="black">
                        <template #activator="{ on }">
                           <w-button  bg-color="warning" v-on="on"  @click="kemaskini(item)" class="be fs-2"><div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-pencil</w-icon>
                           </w-button>
                        </template>
                        Kemaskini
                     </w-tooltip>
                  &nbsp;  
               </w-flex>
            </template>
		  </z-table>
      </div>
      <w-dialog
         v-model="dialog.show"
         :fullscreen="dialog.fullscreen"
         :width="dialog.width"
         :persistent="dialog.persistent"
         :persistent-no-animation="dialog.persistentNoAnimation"
         title-class="primary-dark1--bg white">
         <template #title>
            <w-icon class="mr2">fal fa-cog</w-icon>
               {{dialog.title}}
         </template>
         <w-form 
            ref="form" 
            v-model="dialog.valid"
            @validate="simpan"
            @success="success"
         >
            <z-input label="Bil Terpakai" v-model="form.terpakai" name="Nama" readonly outline/>
            <z-input label="Bil Straw Dilupus/Rosak" v-model="form.rusak" :max="baki_asal" name="Nama" @input="countKuantiti(form,1)" outline/>
            <z-input label="Bil Straw Diuji" v-model="form.hilang" :max="baki_asal" name="Nama" @input="countKuantiti(form,2)" outline/>
            <z-input type="number" label="Baki Straw" v-model="form.baki" name="baki" readonly outline/><br>
               <!-- <div style="margin:5px;" class="fw-normal my1 fs-1"><b> Pindah Milik : </b>
                  <w-switch class="mr6" v-model="pindahmilik"></w-switch>
               </div>
            <template v-if="pindahmilik==1">
               <w-select class="mt4" outline :items="juruteknik_list" label="Nama Penyelaras *"  v-model="form.aiman_id"  :validators="[validators.required]"/>
               <z-input type="number" label="Kuantiti Baki *" v-model="form.kuantiti_pindah" name="Nama" outline/>
            </template> -->
         </w-form>
         <template #actions>
            <div class="spacer" />
            <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
            <w-button 
            class="ml1" 
            :loading="dialog.loading"
            @click="$refs.form.validate()"
            >
              SIMPAN
            </w-button>
         </template>
      </w-dialog>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
    roles: [Array, Object],
    role: String,
  },
  data() {
    return {
      resourceurl: 'embrio.inventori',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Embrio Beku', route: '/embrio' },
        { label: 'Pengurusan Inventori', route: '/embrio/inventori' },
      ],
      pencarian: {
         no_batch: '',
         se_katalog_id: '',
         role_id: this.role
      },
      se_katalog: [],
      form: [],
      pindahmilik: 0,
      baki_asal: 0,
      juruteknik_list: [],
    }
  },
  methods: {
    cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },
    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },
    getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/id_ternakan', {}).then(res => {
        this.se_katalog = res
      })
    },
    countKuantiti(data, jenis){

         if (data.hilang > 0 || data.rusak > 0) {
            var hilang_rusak = Number(data.rusak) + Number(data.hilang);
            data.baki = Number(this.baki_asal) - Number(hilang_rusak);
         } else {
            data.baki = this.baki_asal;
         }
         console.log("Sesudah:", data.baki);
         // if (data.hilang > 0 || data.rusak > 0) {
         //    var hilang_rusak = data.rusak + data.hilang;
         //    data.baki = this.baki_asal - hilang_rusak;
         //    // this.countHilang();
         // }
      },
      countHilang(data){
         data.baki = this.baki_asal - data.hilang;
      },
      kemaskini(form){
          this.form = form;
          this.dialog.show = true
          this.baki_asal = form.baki;
          this.pindahmilik = 0;
          this.dialog.title = 'KEMASKINI'
          this.form.saveButton = "Save"
      },
      simpan() {
         this.dialog.loading = true
         if (this.form.no > 0) {
            this.form.role_id = this.pencarian.role_id ? this.pencarian.role_id :'';
            this.$zcomm.update(this.resourceurl + '.update', this.form.no, this.form)
            .then(res => {
                //update displayed record
                this.mapreturneddata(res)
                this.dialog.show = false;
              if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
                this.$inertia.visit(this.$page.url)
            })
            .catch(err => {

            })
            .finally(() => {
                this.dialog.loading = false
                // this.dialog.show = false

            });
         }else{
            this.dialog.loading = false
         }
     },
    
  
  },

  watch: {

  },
  mounted() {
    this.getKatalog();
    this.dialog.width = 500
      
  },
}
</script>
